export enum TherapyPlanTypeEnum {
  Surgical = 'Surgical', // operativ
  Conservative = 'Conservative'
}

export const TherapyPlanTypeTranslations = {
  getTranslationByKey: getTranslation
};

function getTranslation(type: TherapyPlanTypeEnum): string {
  switch (type) {
    case TherapyPlanTypeEnum.Surgical:
      return 'Operativ';
    case TherapyPlanTypeEnum.Conservative:
      return 'Konservativ';
    default:
      return '';
  }
}
